"use client";
import {
  switch_default
} from "./chunk-VMWQTXAV.mjs";
import {
  useSwitch
} from "./chunk-JYO7OWIA.mjs";
export {
  switch_default as Switch,
  useSwitch
};
